"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _consts = require("./../consts.js");

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzLoading__Wrapper",
  componentId: "sc-1c05vho-0"
})(["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n"]);

var Spinner = _styledComponents.default.div.withConfig({
  displayName: "OzLoading__Spinner",
  componentId: "sc-1c05vho-1"
})(["\n  width: 40px;\n  height: 40px;\n\n\n  border-radius: 50%;\n  background: ", ";\n  background: linear-gradient(to right, ", " 10%,transparent 40%);\n  position: relative;\n  animation: rotating 0.3s infinite linear;\n  transform: translateZ(0);\n\n\n  &:after {\n    background: ", ";\n    width: 75%;\n    height: 75%;\n    border-radius: 50%;\n    content: '';\n    margin: auto;\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  }\n\n  @keyframes rotating {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n"], _consts.CHETWODEBLUE, _consts.CHETWODEBLUE, function (props) {
  return props.bgcolor;
});

var OzLoading = function OzLoading(_ref) {
  var _ref$bgcolor = _ref.bgcolor,
      bgcolor = _ref$bgcolor === void 0 ? _consts.GHOSTWHITE : _ref$bgcolor;
  return __jsx(Wrapper, null, __jsx(Spinner, {
    bgcolor: bgcolor
  }));
};

var _default = OzLoading;
exports.default = _default;